import AMAZON from './amazon.png';
import BBRASIL from './bancodobrasil.png';
import BLING from './bling.png';
import BRADESCO from './bradesco.png';
import CEF from './caixa.png';
import GPTMAKER from './gptmaker.png';
import INCUBADORA_E from './incubadora_e.png';
import INCUBADORA_R from './incubadora_r.png';
import ITAU from './itau.png';
import KWAI from './kwai.png';
import MADEIRAMADEIRA from './madeiramadeira.png';
import MAGAZINELUIZA from './magalu.png';
import MERCADOLIVRE from './mercadolivre.png';
import MERCOS from './mercos.png';
import NUVEMSHOP from './nuvemshop.png';
import OMIE from './omie.png';
import SAFRA from './safra.png';
import SANTANDER from './santander.png';
import SHEIN from './shein.png';
import SHOPEE from './shopee.png';
import SHOPIFY from './shopify.png';
import SICOOB from './sicoob.png';
import SICRED from './sicredi.png';
import SISPRIME from './sisprime.png';
import TIKTOK from './tiktok.png';
import TINY from './tiny.png';
import TRAY from './tray.png';
import WOO from './woocommerce.png';
import WHATSAPP from './whatsapp.png';

export const logos = {
  AMAZON,
  BBRASIL,
  BLING,
  BRADESCO,
  CEF,
  GPTMAKER,
  INCUBADORA_E,
  INCUBADORA_R,
  ITAU,
  KWAI,
  MADEIRAMADEIRA,
  MAGAZINELUIZA,
  MERCADOLIVRE,
  MERCOS,
  NUVEMSHOP,
  OMIE,
  SAFRA,
  SANTANDER,
  SHEIN,
  SHOPEE,
  SHOPIFY,
  SICOOB,
  SICRED,
  SISPRIME,
  TIKTOK,
  TINY,
  TRAY,
  WOO,
  WHATSAPP,
};
